<template>
  <div class="error-page" >
      <div class="error-content">
            <img class="error-img" src="../../assets/img/error.png" />
            <p class="error-msg">{{message}}</p>
      </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      message:''
    };
  },
  components: {
    
  },
  computed: {
    
  },
  methods: {
   
  },
  mounted() {

  },
  created(){
      this.message = decodeURIComponent(this.$route.query.message) 
  }
};
</script>
<style lang="scss" scoped>
$pole:75;
.error-page{
    min-height: 100vh;
    background: #fff;
    align-items:center;
    justify-content:center;
    display: flex;
    .error-content{
        margin-top:-3rem;
        text-align: center;
    }
    .error-img{
        width: 250rem/$pole;
        margin: 0 auto;
    }
    p.error-msg{
        // color: red;
        margin-top:0.5rem;
        font-size: 32rem/$pole;
        text-align: center;
        max-height: 10rem;
        padding: 0 40rem/$pole;
    }
}
</style>